import { useContext } from 'react'
import { CampaignContext } from '../context/campaignContext'

export const useCampaign = () => useContext(CampaignContext)
